import { render } from "./modal.vue?vue&type=template&id=8d1f6f46&scoped=true"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=8d1f6f46&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8d1f6f46"

export default script